import React from "react";

export default function SuccessToast({
  title = "Success",
  message,
  onDismiss,
  testId = "success-toast",
}) {
  if (!message) return null;

  return (
    <div
      className="card border border-emerald-200 bg-emerald-50 p-5 text-emerald-700"
      role="status"
      aria-live="polite"
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-base font-semibold">{title}</p>
          <p className="mt-1 text-sm text-emerald-700">{message}</p>
        </div>
        {onDismiss && (
          <button
            type="button"
            className="text-xs text-emerald-700 underline underline-offset-2"
            onClick={onDismiss}
            aria-label="Dismiss success message"
          >
            Dismiss
          </button>
        )}
      </div>
    </div>
  );
}
